<template>
	<el-tabs type="border-card" v-model="tabs" @tab-remove="Tabremove">
		<el-tab-pane label="优惠券" name="lie">
			<el-table :data="shu" style="width: 100%" stripe>
				<el-table-column prop="id" label="ID" width="80" />
				<el-table-column prop="biaoti" label="标题" width="120" />
				<el-table-column :formatter="formatter" label="使用条件/优惠" width="200" />
				<el-table-column prop="xianling" label="每人限领" width="100" />
				<el-table-column prop="zongshu" label="总发行" width="100" />
				<el-table-column prop="shengyu" label="剩余" width="100" />
				<el-table-column :formatter="function(a){return a.zongshu-a.shengyu}" label="已领取" width="100" />
				<el-table-column prop="yishiyong" label="已使用" width="100" />
				<el-table-column :formatter="function(a){return a.kaishi+'至'+a.jieshu}" label="有效期限" width="250" />
				<el-table-column prop="caozuo" label="操作">
					<template slot-scope="shu">
						<el-button icon="el-icon-edit-outline" size="mini"  @click="Bianji(shu.row)"></el-button>
						<el-button icon="el-icon-close" size="mini" @click="Shanchu(shu)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination layout="total,prev,pager,next,jumper" :total="zongshu" :page-size.sync="so.jitiao" :current-page.sync="so.ye"
			 @current-change="CSH" style="margin-top: 30px;" />

		</el-tab-pane>
		<el-tab-pane :label="quan.id?'编辑':'新增'" name="xinzeng" :closable="quan.id>0">
			<el-form ref="quan" :model="quan" label-width="80px">
				<el-form-item label="标题" :rules="[{required: true, message: '不能为空'}]">
					<el-input v-model="quan.biaoti"></el-input>
				</el-form-item>

				<el-form-item label="使用条件" :rules="[{required: true, message: '不能为空'},{ type: 'number', message: '必须为数字值'}]">
					<el-input v-model="quan.tiaojian"></el-input>
				</el-form-item>
				<el-form-item label="有效期限" required>
					<el-date-picker v-model="quan.youxiaoqi" type="daterange" range-separator="至" start-placeholder="开始日期"
					 end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="优惠金额" :rules="[{required: true, message: '不能为空'},{ type: 'number', message: '必须为数字值'}]">
					<el-input v-model="quan.e"></el-input>
				</el-form-item>
				<el-form-item label="发放总数" :rules="[{required: true, message: '不能为空'},{ type: 'number', message: '必须为数字值'}]">
					<el-input v-model="quan.zongshu"></el-input>

				</el-form-item>
				<el-form-item label="每人限领" :rules="[{ type: 'number', message: '必须为数字值'}]">
					<el-input v-model="quan.xianling"></el-input>
				</el-form-item>
				<el-form-item label="是否开启">
					<el-radio-group v-model="quan.zhuangtai">
						<el-radio label="0">关闭</el-radio>
						<el-radio label="1">开启</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<Tijiao type="danger" @click="Tijiao">提交</Tijiao>
				</el-form-item>
			</el-form>
		</el-tab-pane>
	</el-tabs>
</template>


<script>
	let that;
	import Shangtu from '../../zujian/Shangtu.vue'
	export default {
		data() {
			return {
				so: {
					ye: 1,
					jitiao: 20
				},
				shu: [],
				zongshu: 0,
				quan: {},
				tabs: 'lie',
			};
		},
		components: {
			Shangtu,
		},
		created() {
			that = this;
			that.CSH();
		},
		methods: {
			CSH() {
				this.$post('k=quan', this.so, function(s) {
					that.shu = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
			Tijiao() {
				that.$post('k=quan&c=xiugai', that.quan, function(s) {
					that.$xiaoxi(s.shu)
					if (s.shi == 1) {						 
						that.CSH();
						if(!that.quan.id){
							that.Tabremove();
						}
					}
				});
			},
			formatter(a) {
				return "满" + a.tiaojian + "元优惠" + a.e + "元";
			},
			Shanchu(e) {
				this.$confirm('确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.shu.splice(e.$index, 1);
					this.$post('k=quan&c=shandian', {
						id: e.row.id
					}, function(s) {
						if (s.shi != 1) {
							that.$xiaoxi(s.shu);
						}
					});
				});
			},
			Tabremove(e) {
				that.tabs = 'lie';
				that.quan = {};
			},
			Bianji(e){		
				that.tabs='xinzeng';
				that.quan=e;				
			}
		}
	};
</script>
<style>
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.tishi {
		margin-left: 6px;
		color: #737373;
	}
</style>
